import React, { useState } from "react";
import { FacebookShareButton, EmailShareButton } from "react-share";
import styles from "./ShareThisCourse.module.css";
import Button from "@mui/material/Button";
import Buttons from "../Button/Button";
import Facebook from "../../assets/imgs/socialIcon/facebook.svg";
import WhatsApp from "../../assets/imgs/socialIcon/whats-app.svg";
import Messenger from "../../assets/imgs/socialIcon/messenger.svg";
import Email from "../../assets/imgs/socialIcon/email.svg";
import Twitter from "../../assets/imgs/socialIcon/twitter.svg";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Image from "next/image";
import { useEffect } from "react";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";

function ShareThisCourse(props) {
  const { course, instructorFullName, showTitle } = props;

  const [isCopied, setIsCopied] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);

  const [courseShareLink, setCourseShareLink] = useState("");

  useEffect(() => {
    setHasMounted(true);
    // Check if window is defined (client-side)
    if (typeof window !== "undefined") {
      setCourseShareLink(
        typeof course.detailLink !== "undefined"
          ? window.location.origin + course.detailLink
          : window.location.href
      );
    }
  }, [course.detailLink]);

  // do the text copy operation
  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Check if window is defined (client-side)
    if (typeof window !== "undefined") {
      // Asynchronously call courseShareLinkToClipboard
      copyTextToClipboard(`${window.location.origin}/learn/${course?.courseSlug}`)
        .then(() => {
          // If successful, update the isCopied state value
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 1500000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  // console.log(course);
  const instructorName = instructorFullName
    ? instructorFullName
    : course?.leadInstructor;

  return (
    <div className={`${styles.ShareThisCourse} ${"WhiteSection"}`}>
      {showTitle == true && <h1 className="TitleSmall">Share this course</h1>}

      <div className={styles.SocialLinks}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <div className={styles.SocialButtons}>
              <FacebookShareButton
                url={courseShareLink}
                quotes={course.courseTitle}
                // hashtag={"#hashtag"}
                description={course.description}
                style={{ minHeight: "64px", paddingLeft: "19px" }}
                className={styles.ShareButton}
              >
                <Image src={Facebook} /> &nbsp; Facebook
              </FacebookShareButton>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <div className={styles.SocialButtons}>
              <EmailShareButton
                subject={course.courseTitle}
                body={`Thought you might like this course at Takbir : ${course.courseTitle} with ${instructorName}.\nCourse details available at here: ${courseShareLink}\nTakbir (mytakbir.com) is an online, secured and easy-to-use platform for learners and amazing teachers. \nFollow Takbir - https://www.facebook.com/mytakbir`}
                separator=" "
                url={""}
                style={{ minHeight: "64px", paddingLeft: "19px" }}
                className={styles.ShareButton}
              >
                {/* <Image src={Email} /> &nbsp; Email */}
                <EmailOutlinedIcon sx={{ fontSize: "32px !important" }} />{" "}
                &nbsp; Email
              </EmailShareButton>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <p className="HelperTextSocial">
              Copy and paste this link anywhere
            </p>
            <div className="TextField ModalCopyField">


              <div className={styles.UrlSection}>
                {hasMounted
                  ? `${window.location.origin}/learn/${course?.courseSlug}`
                  : `/learn/${course?.courseSlug}`
                }
              </div>
              <div className="CopyFieldButtonContainer">
                <Buttons
                  label={isCopied ? "Copied!" : "Copy Link"}
                  buttonColor="#004FE0"
                  color="#fff"
                  height="48px"
                  fontSize="14px"
                  link=""
                  width="100%"
                  onClick={handleCopyClick}
                />
              </div>
              <div style={{ marginBottom: "10px" }}></div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default ShareThisCourse;
